export default __webpack_public_path__ + "static/media/user.d70317ef.svg";